import apiClient from './base';

export interface Patient {
  id_utente: number;
  nome: string;
  cognome: string;
  codice_fiscale: string;
  data_nascita: string;
  email: string;
  telefono: string;
  id_creatore: number;
}

interface GetPatientsResponse {
  message: string;
  users: Patient[];
}

export const getPatients = async (userId: number | null): Promise<Patient[]> => {
  try {
    const response = await apiClient.post<GetPatientsResponse>(
      '/users/fetch.php',
      { id_creatore: userId },
      { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
    );
    return response.data.users;
  } catch (error: any) {
    if (error.response) {
      throw new Error(error.response.data.message || 'Error fetching patients');
    } else {
      throw new Error('Error fetching patients');
    }
  }
};

// 🔹 Create paziente (registrazione)
export const createPatient = async (payload: {
  nome: string;
  cognome: string;
  email: string;
  password: string;
  codice_fiscale: string;
  data_nascita: string;
  altezza?: number;
  peso?: number;
  genere: 'M' | 'F';
  id_tipo_utente: number;
  codice_regione?: string;
  sigla_provincia?: string;
  codice_istat?: string;
  cap?: string;
}): Promise<{ message: string; userId: number }> => {
  try {
    const response = await apiClient.post<{ message: string; userId: number }>(
      '/users/create.php',
      payload,
      { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
    );
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(error.response.data.message || 'Error creating patient');
    } else {
      throw new Error('Error creating patient');
    }
  }
};

// 🔹 Update paziente
export const updatePatient = async (
  id_utente: number,
  payload: Partial<Pick<Patient, 'nome' | 'cognome' | 'codice_fiscale' | 'data_nascita' | 'email' | 'telefono'>>
): Promise<Patient> => {
  try {
    const response = await apiClient.post<{ message: string; user: Patient }>(
      '/users/update.php',
      { id_utente, ...payload },
      { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
    );
    return response.data.user;
  } catch (error: any) {
    if (error.response) {
      throw new Error(error.response.data.message || 'Error updating patient');
    } else {
      throw new Error('Error updating patient');
    }
  }
};

// 🔹 Delete paziente
export const deletePatient = async (id_utente: number): Promise<void> => {
  try {
    await apiClient.post<{ message: string }>(
      '/users/delete.php',
      { id_utente },
      { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
    );
  } catch (error: any) {
    if (error.response) {
      throw new Error(error.response.data.message || 'Error deleting patient');
    } else {
      throw new Error('Error deleting patient');
    }
  }
};
